export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M4 9h16v2H4zm0 4h10v2H4z\"/>"
};